import Vue from 'vue'

export default function toast(arg1, arg2) {
  let type = ''
  let msg = ''

  if (arg2) {
    [type, msg] = [arg1, arg2]
  } else {
    msg = arg1
  }

  if (!type) {
    Vue.prototype.$toast(msg)
    return
  }
  Vue.prototype.$toast(type, msg)
}



// WEBPACK FOOTER //
// ./src/utils/toast.js